import store from '../store/index';

export default {
  ClearSession() {
    this.ClearUserInfo();
    this.ClearEligibility();
    // this.ClearSiteData();
    this.ClearExistingBooking();
    this.ClearAvailableLocations();
    this.ClearCustomerDetailsPage();
    this.ClearBookingDetails();
  },
  ClearUserInfo() {
    console.log('Inside ClearUserInfo of SessionState');
    store.dispatch({
      type: 'userInfo/firstName',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/lastName',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/dateOfBirth',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/dLNumber',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/testType',
      value: 'D',
    });
    store.dispatch({
      type: 'userInfo/testTypeText',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/testTypeId',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/email',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/phone',
      value: '',
    });
    store.dispatch({
      type: 'userInfo/homePhone',
      value: '',
    });
  },
  ClearEligibility() {
    console.log('Inside ClearEligibility of SessionState');
    store.dispatch('beginDate', { value: '' });
    store.dispatch('endDate', { value: '' });
    store.dispatch('responseID', { value: '' });
  },
  ClearSiteData() {
    console.log('Inside ClearSiteData of SessionState');
    store.dispatch('serviceTypes', { value: [] });
    store.dispatch('cities', { value: [] });
  },
  ClearExistingBooking() {
    console.log('Inside ClearExistingBooking of SessionState');
    store.dispatch('existingAppointment', { value: false });
    store.dispatch('isNewServiceType', { value: false });
    store.dispatch('booking', { value: [] });
  },
  ClearAvailableLocations() {
    console.log('Inside ClearAvailableLocations of SessionState');
    store.dispatch('availableLocation', { value: [] });
    store.dispatch('selectedLocation', { value: '' });
  },
  ClearCustomerDetailsPage() {
    console.log('Inside ClearCustomerDetailsPage of SessionState');
    store.dispatch('dayOfWeek', { value: 0 });
    store.dispatch('zipCodeValue', { value: '' });
    store.dispatch('cityTown', { value: '' });
    store.dispatch('textMsgCheckBox', { value: false });
  },
  ClearBookingDetails() {
    console.log('Inside ClearBookingDetails of SessionState');
    store.dispatch({
      type: 'bookingDetails/siteName',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/siteAddress',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/confirmationNumber',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/formattedCheckinDateTime',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/bookingDateTime',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/bookingDuration',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/siteId',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/sendSms',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/slotId',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/rescheduleBooking',
      value: false,
    });
    store.dispatch({
      type: 'bookingDetails/serviceType',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/serviceTypeText',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/serviceTypeId',
      value: '',
    });
    store.dispatch({
      type: 'bookingDetails/newAppointmentSelected',
      value: false,
    });
  },
};
